export const global_height_breakpoint_2xl = {
  "name": "--pf-global--height-breakpoint--2xl",
  "value": "80rem",
  "var": "var(--pf-global--height-breakpoint--2xl)"
};
export default global_height_breakpoint_2xl;